import React from 'react';

import { DropDownItem } from '../../types';
import { LinksCard, LinksTitle, LinksWrapper } from './styled';

type Props = {
  list: Array<DropDownItem>;
};

const LinksDropDown = ({ list }: Props): JSX.Element => (
  <LinksWrapper>
    <LinksCard>
      {list.map((item: DropDownItem) => (
        <LinksTitle $isActive href={item.url} key={item.title} target="_blank" rel="noopener noreferrer">
          {item.title}
        </LinksTitle>
      ))}
    </LinksCard>
  </LinksWrapper>
);

export default LinksDropDown;
